import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, AfterViewInit, ViewChild, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import Chart from 'chart.js/auto';

@Component({
    selector: 'app-show-group-ctm',
    imports: [CommonModule, MatTooltipModule],
    templateUrl: './show-group-ctm.component.html',
    styleUrl: './show-group-ctm.component.scss'
})
export class ShowGroupCtmComponent implements AfterViewInit, OnDestroy {

  private readonly mockSmartCtm: any[] = [
    {
      "name": "Pista 1",
      "serial": "CTM124C6C2A4",
      "consumo": 1200,
      "online": true,
      "activo": true,
      "historialAnual": [100, 95, 105, 90, 110, 95, 100, 95, 95, 110, 100, 105],
      "historialMensual": [2, 3, 4, 1, 5, 2, 4, 3, 2, 1, 5, 2, 4, 3, 1, 4, 5, 2, 3, 1, 5, 2, 4, 3, 2, 1, 4, 5, 2, 3],
      "activoPorDia": [60, 90, 45, 120, 75, 80, 100, 50, 95, 110, 85, 70, 65, 90, 120, 55, 100, 95, 60, 80, 90, 110, 75, 85, 95, 100, 60, 120, 90, 70],
      "tiempoActivo": 2660
    },
    {
      "name": "Pista 2",
      "serial": "CTM124C6C2A5",
      "consumo": 1400,
      "online": true,
      "activo": true,
      "historialAnual": [120, 110, 100, 95, 115, 105, 120, 110, 115, 95, 100, 115],
      "historialMensual": [3, 1, 4, 2, 3, 2, 5, 3, 1, 2, 4, 3, 2, 5, 1, 3, 2, 4, 1, 3, 5, 2, 3, 4, 1, 2, 3, 5, 1, 2],
      "activoPorDia": [70, 85, 60, 100, 120, 65, 90, 80, 75, 95, 110, 60, 70, 85, 90, 100, 105, 80, 95, 110, 85, 70, 100, 95, 120, 75, 85, 110, 95, 100],
      "tiempoActivo": 2820
    },
    {
      "name": "Pista 3",
      "serial": "CTM124C6C2A6",
      "consumo": 1600,
      "online": false,
      "activo": false,
      "historialAnual": [130, 120, 110, 100, 120, 130, 125, 110, 120, 115, 110, 110],
      "historialMensual": [4, 2, 3, 5, 1, 2, 4, 3, 2, 5, 1, 4, 2, 3, 5, 2, 4, 1, 3, 2, 4, 3, 5, 1, 2, 3, 4, 2, 5, 1],
      "activoPorDia": [80, 60, 75, 90, 100, 65, 85, 70, 95, 120, 100, 80, 75, 110, 105, 60, 95, 100, 85, 90, 75, 100, 95, 120, 85, 65, 95, 110, 80, 90],
      "tiempoActivo": 2700
    },
    {
      "name": "Pista 4",
      "serial": "CTM124C6C2A7",
      "consumo": 1000,
      "online": true,
      "activo": true,
      "historialAnual": [80, 85, 90, 75, 95, 85, 80, 85, 80, 95, 85, 80],
      "historialMensual": [2, 2, 3, 1, 4, 2, 3, 1, 2, 3, 2, 1, 4, 2, 3, 1, 2, 2, 3, 1, 4, 2, 3, 1, 2, 3, 2, 1, 4, 2],
      "activoPorDia": [55, 65, 70, 80, 75, 60, 85, 90, 95, 100, 65, 70, 80, 85, 90, 75, 95, 100, 85, 70, 65, 85, 95, 75, 70, 85, 95, 100, 65, 75],
      "tiempoActivo": 2360
    },
    {
      "name": "Pista 5",
      "serial": "CTM124C6C2A8",
      "consumo": 1800,
      "online": false,
      "activo": false,
      "historialAnual": [150, 140, 135, 120, 150, 140, 130, 145, 150, 135, 140, 165],
      "historialMensual": [5, 3, 4, 2, 3, 5, 2, 4, 3, 2, 4, 5, 3, 2, 4, 3, 5, 2, 3, 4, 2, 5, 3, 2, 4, 3, 5, 2, 4, 3],
      "activoPorDia": [90, 100, 120, 110, 95, 105, 100, 115, 120, 90, 85, 95, 110, 120, 100, 115, 95, 110, 120, 105, 95, 100, 110, 90, 120, 100, 95, 115, 120, 105],
      "tiempoActivo": 3095
    },
    {
      "name": "Pista 6",
      "serial": "CTM124C6C2A9",
      "consumo": 1500,
      "online": true,
      "activo": true,
      "historialAnual": [120, 115, 125, 110, 130, 115, 120, 125, 115, 120, 115, 130],
      "historialMensual": [3, 2, 4, 1, 5, 2, 4, 3, 2, 1, 5, 3, 2, 4, 1, 3, 2, 4, 5, 1, 3, 2, 4, 5, 3, 1, 2, 4, 3, 5],
      "activoPorDia": [85, 75, 90, 100, 95, 105, 110, 120, 85, 90, 100, 115, 120, 95, 100, 110, 85, 95, 120, 100, 85, 95, 110, 105, 120, 85, 100, 95, 115, 105],
      "tiempoActivo": 2920
    }
  ];

  smartCtm: any[] = this.mockSmartCtm.map(item => ({ ...item }));

  @Input() set devices(_: any[] | null | undefined) {
    this.smartCtm = this.mockSmartCtm.map(item => ({ ...item }));
    this.refreshChartIfReady();
  }

  private _loading = false;

  @Input()
  set loading(value: boolean) {
    this._loading = value;
    this.refreshChartIfReady();
  }

  get loading(): boolean {
    return this._loading;
  }

  private viewInitialized = false;

  currentChartType: 'devices' | 'status' = 'devices';
  chartTitle = 'Distribución por dispositivos';
  deviceColors = ['#ff6384', '#36a2eb', '#4bc0c0', '#ffcd56', '#ff9f40', '#9966ff', '#ff9f40'];
  costColors = ['#28a745', '#17a2b8', '#ffc107', '#fd7e14', '#e83e8c', '#6f42c1', '#20c997'];
  chartViewType: 'consumption' | 'trend' | 'cost' = 'consumption';
  Math = Math;

  private ctmBarChartCanvas?: ElementRef<HTMLCanvasElement>;

  @ViewChild('ctmBarChart')
  private set chartCanvas(canvas: ElementRef<HTMLCanvasElement> | undefined) {
    this.ctmBarChartCanvas = canvas;
    this.refreshChartIfReady();
  }
  private ctmBarChartInstance: Chart | null = null;

  constructor(private _router: Router) {}

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.refreshChartIfReady();
  }

  ngOnDestroy(): void {
    this.destroyChart();
  }

  getTotalDevices(): number {
    return this.smartCtm?.length || 0;
  }

  getConnectedDevices(): number {
    return this.smartCtm?.filter(ctm => ctm.online === true)?.length || 0;
  }

  getTotalConsumption(): number {
    return this.smartCtm?.reduce((total, ctm) => {
      return total + (ctm.consumo || 0);
    }, 0) || 0;
  }

  getActiveSessions(): number {
    return this.smartCtm?.filter(ctm => ctm.activo === true)?.length || 0;
  }

  getAverageConsumption(): number {
    const total = this.getTotalConsumption();
    const count = this.getTotalDevices();
    return count > 0 ? parseFloat((total / count).toFixed(2)) : 0;
  }

  getMaxPower(): number {
    const total = this.getTotalConsumption();
    return parseFloat((total / 424).toFixed(1));
  }

  getEstimatedCost(): number {
    const total = this.getTotalConsumption();
    return parseFloat((total * 0.168).toFixed(2));
  }

  getMonthlyChangePercentage(): number {
    return -3;
  }

  isSystemActive(): boolean {
    return this.getConnectedDevices() > 0;
  }

  getTopConsumer(): string {
    if (!this.smartCtm || this.smartCtm.length === 0) return 'N/A';
    const topDevice = this.smartCtm.reduce((max, ctm) =>
      ctm.consumo > max.consumo ? ctm : max
    );
    return `${topDevice.name} (${topDevice.consumo} kWh)`;
  }

  getTopConsumerName(): string {
    if (!this.smartCtm || this.smartCtm.length === 0) return 'N/A';
    const topDevice = this.smartCtm.reduce((max, ctm) =>
      ctm.consumo > max.consumo ? ctm : max
    );
    return topDevice.name || topDevice.serial;
  }

  getTopConsumerValue(): number {
    if (!this.smartCtm || this.smartCtm.length === 0) return 0;
    const topDevice = this.smartCtm.reduce((max, ctm) =>
      ctm.consumo > max.consumo ? ctm : max
    );
    return topDevice.consumo;
  }

  getCtmStatusBadgeClass(online: boolean): string {
    return online ? 'badge-success' : 'badge-danger';
  }

  getCtmStatusText(online: boolean): string {
    return online ? 'Online' : 'Offline';
  }

  getCtmConnectionClass(online: boolean): string {
    return online ? 'badge-primary' : 'badge-secondary';
  }

  getCtmConnectionText(online: boolean): string {
    return online ? 'Conectado' : 'Desconectado';
  }

  getCtmActiveClass(activo: boolean): string {
    return activo ? 'badge-success' : 'badge-secondary';
  }

  getCtmActiveText(activo: boolean): string {
    return activo ? 'Activo' : 'Inactivo';
  }

  getCtmLastUpdate(): string {
    return 'Hace 5 minutos';
  }

  getCtmTotalTime(ctm: any): string {
    const totalMinutes = ctm.tiempoActivo || 0;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  getCtmRemainingTime(ctm: any): string {
    if (!ctm.activo) {
      return '--';
    }

    const remainingTimes = [
      '45m',
      '1h 15m',
      '30m',
      '2h 00m',
      '1h 30m',
      '15m'
    ];

    const index = this.smartCtm.indexOf(ctm);
    return remainingTimes[index] || '1h 00m';
  }

  getCtmCurrentUser(ctm: any): string {
    if (!ctm.activo) {
      return '--';
    }

    const currentUsers = [
      'Juan Pérez',
      'María García',
      'Carlos López',
      'Ana Martín',
      'Luis Rodríguez',
      'Elena Fernández'
    ];

    const index = this.smartCtm.indexOf(ctm);
    return currentUsers[index] || 'Usuario';
  }

  getTotalTimeFormatted(): string {
    const totalMinutes = this.smartCtm?.reduce((total, ctm) => {
      return total + (ctm.tiempoActivo || 0);
    }, 0) || 0;

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  goToCtmDevice(serial: string): void {
    this._router.navigateByUrl(`/dashboard/device/${serial}`);
  }

  goToCtmSettings(serial: string): void {
    this._router.navigateByUrl(`/dashboard/device/${serial}/settings`);
  }

  downloadCtmReport(serial: string): void {
    console.log(`Descargando reporte para ${serial}`);
  }

  switchChartView(type: 'consumption' | 'trend' | 'cost'): void {
    this.chartViewType = type;
    this.refreshChartIfReady();
  }

  private refreshChartIfReady(): void {
    if (!this.viewInitialized) {
      return;
    }

    if (this.loading || !this.ctmBarChartCanvas || !this.smartCtm || this.smartCtm.length === 0) {
      this.destroyChart();
      return;
    }

    this.renderCurrentChart();
  }

  private renderCurrentChart(): void {
    if (this.chartViewType === 'cost') {
      this.initializeCtmCostChart();
    } else if (this.chartViewType === 'trend') {
      this.initializeCtmTrendChart();
    } else {
      this.initializeCtmBarChart();
    }
  }

  private destroyChart(): void {
    if (this.ctmBarChartInstance) {
      this.ctmBarChartInstance.destroy();
      this.ctmBarChartInstance = null;
    }
  }

  getChartTitle(): string {
    switch (this.chartViewType) {
      case 'consumption':
        return 'Consumo por dispositivo CTM';
      case 'cost':
        return 'Coste energético por dispositivo CTM';
      case 'trend':
        return 'Tendencia de consumo mensual';
      default:
        return 'Datos de dispositivos CTM';
    }
  }

  initializeCtmBarChart(): void {
    if (!this.ctmBarChartCanvas) {
      console.warn('Canvas del gráfico CTM no encontrado');
      return;
    }

    const canvas = this.ctmBarChartCanvas.nativeElement;
    const context = canvas.getContext('2d');

    if (!context) {
      console.warn('No se pudo obtener el contexto del gráfico CTM');
      return;
    }

    this.destroyChart();

    const labels = this.smartCtm.map(ctm => ctm.name || ctm.serial);
    const data = this.smartCtm.map(ctm => ctm.consumo);
    const backgroundColors = this.deviceColors.slice(0, this.smartCtm.length);

    this.ctmBarChartInstance = new Chart(context, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Consumo (kWh)',
          data: data,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors,
          borderWidth: 2,
          borderRadius: 8,
          barThickness: 60
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const ctm = this.smartCtm[context.dataIndex];
                return [
                  `Consumo: ${context.parsed.y} kWh`,
                  `Estado: ${ctm.online ? 'Online' : 'Offline'}`,
                  `Operativo: ${ctm.activo ? 'Activo' : 'Inactivo'}`
                ];
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => `${value} kWh`
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        }
      }
    });

    console.log('Gráfico de barras CTM inicializado correctamente');
  }

  initializeCtmTrendChart(): void {
    if (!this.ctmBarChartCanvas) {
      console.warn('Canvas del gráfico CTM no encontrado');
      return;
    }

    const canvas = this.ctmBarChartCanvas.nativeElement;
    const context = canvas.getContext('2d');

    if (!context) {
      console.warn('No se pudo obtener el contexto del gráfico CTM');
      return;
    }

    this.destroyChart();

    const months = [];
    const now = new Date();
    for (let i = 11; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push(date.toLocaleDateString('es-ES', { month: 'short', year: '2-digit' }));
    }

    const datasets: any[] = [];

    this.smartCtm.forEach((ctm, index) => {
      const monthlyData = ctm.historial && ctm.historial.length === 12
        ? ctm.historial
        : this.generateMonthlyData(ctm.consumo);

      datasets.push({
        label: ctm.name || ctm.serial,
        data: monthlyData,
        borderColor: this.deviceColors[index],
        backgroundColor: this.deviceColors[index] + '20',
        borderWidth: 2,
        fill: false,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6
      });
    });

    const averageData = this.calculateMonthlyAverages(datasets);
    const averageColor = this.deviceColors[5];

    datasets.push({
      label: 'Promedio del Grupo',
      data: averageData,
      borderColor: averageColor,
      backgroundColor: 'transparent',
      borderWidth: 3,
      borderDash: [10, 5],
      fill: false,
      tension: 0.4,
      pointRadius: 5,
      pointHoverRadius: 7,
      pointStyle: 'rectRot' as const,
      pointBackgroundColor: averageColor,
      pointBorderColor: '#fff',
      pointBorderWidth: 2
    });

    this.ctmBarChartInstance = new Chart(context, {
      type: 'line',
      data: {
        labels: months,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              padding: 15,
              generateLabels: (chart) => {
                const defaultLabels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                defaultLabels.forEach((label: any) => {
                  if (label.text === 'Promedio del Grupo') {
                    label.fontStyle = 'bold';
                    label.fillStyle = this.deviceColors[5];
                  }
                });
                return defaultLabels;
              }
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (context) => {
                const label = context.dataset.label || '';
                const value = context.parsed.y;
                if (label === 'Promedio del Grupo') {
                  return `${label}: ${value} kWh (promedio)`;
                }
                return `${label}: ${value} kWh`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => `${value} kWh`
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        }
      }
    });

    console.log('Gráfico de tendencia CTM inicializado correctamente');
    console.log('Datasets:', datasets);
    console.log('Average data:', averageData);
  }

  initializeCtmCostChart(): void {
    if (!this.ctmBarChartCanvas) {
      console.warn('Canvas del gráfico CTM no encontrado');
      return;
    }

    const canvas = this.ctmBarChartCanvas.nativeElement;
    const context = canvas.getContext('2d');

    if (!context) {
      console.warn('No se pudo obtener el contexto del gráfico CTM');
      return;
    }

    this.destroyChart();

    const labels = this.smartCtm.map(ctm => ctm.name || ctm.serial);
    const costData = this.smartCtm.map(ctm => (ctm.consumo || 0) * 0.15);
    const backgroundColors = this.deviceColors;

    this.ctmBarChartInstance = new Chart(context, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Coste (€)',
          data: costData,
          backgroundColor: backgroundColors.slice(0, this.smartCtm.length),
          borderColor: backgroundColors.slice(0, this.smartCtm.length),
          borderWidth: 2,
          borderRadius: 8,
          barThickness: 60
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const ctm = this.smartCtm[context.dataIndex];
                const consumo = ctm.consumo || 0;
                const costeTotal = consumo * 0.15;
                const costeDiario = consumo * 0.005;
                return [
                  `Coste mensual: ${costeTotal.toFixed(2)}€`,
                  `Coste diario: ${costeDiario.toFixed(2)}€`,
                  `Consumo: ${consumo} kWh`,
                  `Tarifa: 0.15€/kWh`,
                  `Estado: ${ctm.online ? 'Online' : 'Offline'}`
                ];
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => `${Number(value).toFixed(2)}€`
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        }
      }
    });

    console.log('Gráfico de coste CTM inicializado correctamente');
  }

  generateMonthlyData(currentConsumption: number): number[] {
    const monthlyData: number[] = [];
    const baseConsumption = currentConsumption;

    for (let i = 0; i < 12; i++) {
      const variation = (Math.random() - 0.5) * 0.3;
      const monthValue = baseConsumption * (1 + variation);
      monthlyData.push(Math.round(monthValue));
    }

    console.log('Generated monthly data for consumption', currentConsumption, ':', monthlyData);
    return monthlyData;
  }

  calculateMonthlyAverages(datasets: any[]): number[] {
    const numMonths = 12;
    const averages: number[] = [];

    for (let monthIndex = 0; monthIndex < numMonths; monthIndex++) {
      let total = 0;
      let count = 0;

      datasets.forEach(dataset => {
        if (dataset.data && dataset.data[monthIndex] !== undefined && dataset.data[monthIndex] !== null) {
          total += Number(dataset.data[monthIndex]);
          count++;
        }
      });

      const average = count > 0 ? Math.round(total / count) : 0;
      averages.push(average);
    }

    console.log('Calculated monthly averages:', averages);
    return averages;
  }

  getAverageMonthlyConsumption(): number {
    if (!this.smartCtm || this.smartCtm.length === 0) return 0;

    let totalMonthlyAverage = 0;

    this.smartCtm.forEach(ctm => {
      if (ctm.historial && ctm.historial.length > 0) {
        const average = ctm.historial.reduce((sum: number, val: number) => sum + val, 0) / ctm.historial.length;
        totalMonthlyAverage += average;
      } else {
        totalMonthlyAverage += ctm.consumo;
      }
    });

    return Math.round(totalMonthlyAverage);
  }

  getTrendDirection(): number {
    if (!this.smartCtm || this.smartCtm.length === 0) return 0;

    let totalChange = 0;
    let devicesWithHistory = 0;

    this.smartCtm.forEach(ctm => {
      if (ctm.historial && ctm.historial.length >= 2) {
        const lastMonth = ctm.historial[ctm.historial.length - 1];
        const previousMonth = ctm.historial[ctm.historial.length - 2];
        const change = ((lastMonth - previousMonth) / previousMonth) * 100;
        totalChange += change;
        devicesWithHistory++;
      }
    });

    return devicesWithHistory > 0
      ? Math.round((totalChange / devicesWithHistory) * 10) / 10
      : -3;
  }

  getDailyAverageConsumption(): number {
    const total = this.getTotalConsumption();
    return parseFloat((total / 30).toFixed(1));
  }

  getConnectionPercentage(): number {
    const total = this.getTotalDevices();
    if (total === 0) return 0;
    const connected = this.getConnectedDevices();
    return Math.round((connected / total) * 100);
  }

  getOfflineDevices(): number {
    return this.smartCtm?.filter(ctm => ctm.online === false)?.length || 0;
  }

  getGroupHealthStatus(): 'excellent' | 'good' | 'warning' | 'critical' {
    const percentage = this.getConnectionPercentage();
    if (percentage >= 90) return 'excellent';
    if (percentage >= 70) return 'good';
    if (percentage >= 50) return 'warning';
    return 'critical';
  }
}
